import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

export const Header = () => {
  const { t } = useTranslation()

  return <div className={styles.title}>{t('Chat.Sidebar.Title')}</div>
}
